import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { enTranslations } from "../assets/constants/translations-en";
import { ruTranslations } from "../assets/constants/translations-ru";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...enTranslations,
        },
      },
      ru: {
        translation: {
          ...ruTranslations,
        },
      },
    },
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

const localLanguage = localStorage.getItem("language");

if (localLanguage) {
  i18n.changeLanguage(localLanguage);
}

export const changeLanguageHandler = async (lang) => {
  localStorage.setItem("language", lang);
  i18n.changeLanguage(lang);
};

export default i18n;
